export const HIRING_DATE = 'hiring-date';
export const WORKING_HOURS = 'working-hours';
export const EMPLOYMENT_DURATION = 'employment-duration';
export const PLACE_OF_WORK = 'place-of-work';
export const HOME_OFFICE = 'home-office';
export const HOME_OFFICE_ADVANCED = 'home-office-advanced';
export const FUNCTION = 'function';
export const FUNCTION_DETAIL = 'function-detail';
export const FUNCTION_EXPERIENCE = 'function-experience';
export const FUNCTION_ASSISTANCE = 'function-assistance';
export const FUNCTION_LEGAL_FIELD = 'function-legal-field';
export const FUNCTION_LEGAL_FIELD_EXPERIENCE = 'function-legal-field-experience';
export const FUNCTION_LEGAL_ROLE = 'function-legal-role';
export const FUNCTION_LEGAL_ROLE_EXPERIENCE = 'function-legal-role-experience';
export const FUNCTION_TAX_FIELD = 'function-tax-field';
export const FUNCTION_TAX_FIELD_EXPERIENCE = 'function-tax-field-experience';
export const FUNCTION_TAX_ROLE = 'function-tax-role';
export const FUNCTION_TAX_ROLE_EXPERIENCE = 'function-tax-role-experience';
export const FUNCTION_MARKETING_ROLE = 'function-marketing-role';
export const FUNCTION_MARKETING_ROLE_EXPERIENCE = 'function-marketing-role-experience';
export const CAREER_LEVEL = 'career-level';
export const CAREER_LEVEL_EXPERIENCE = 'career-level-experience';
export const INDUSTRIAL_SECTOR = 'industrial-sector';
export const INDUSTRIAL_SECTOR_EXPERIENCE = 'industrial-sector-experience';
export const EMPLOYMENT_MODE = 'employment-mode';
export const SALARY = 'salary';
export const HOURLY_RATE = 'hourly-rate';
export const COMPANY_TYPE = 'company-type';
export const COMPANY_SIZE = 'company-size';
export const SEARCH_STATUS = 'search-status';
export const GENDER = 'gender';
export const AGE = 'age';
export const MANAGEMENT = 'management';
export const CITIZENSHIP = 'citizenship';
export const DRIVING_LICENSE = 'driving-license';
export const PILOT_LICENSE = 'pilot-license';
export const PRIVATE_VEHICLE_COMPANY_USAGE = 'private-vehicle-company-usage';
export const COMPANY_CAR = 'company-car';
export const LANGUAGE = 'language';
export const TRAVEL_WILLINGNESS = 'travel-willingness';
export const EXTERNAL_SLEEPOVER = 'external-sleepover';
export const BENEFITS = 'benefits';
export const PARKING = 'parking';
export const PUBLIC_TRANSPORT = 'public-transport';
export const OVERTIME = 'overtime';
export const INTERESTS = 'interests';
export const SOFTWARE_MAIN = 'software-main';
export const SOFTWARE_SPECIAL = 'software-special';
export const SKILLS = 'skills';
export const EDUCATION = 'education';
export const WORKING_TIME = 'working-time';
export const RELOCATION_PREMISE = 'relocation-premise';
export const CUSTOMER_CONTACT = 'customer-contact';
export const LEGITIMATION = 'legitimation';
export const INCOGNITO_MODE = 'incognito-mode';
export const ORGANISATIONAL_AREA = 'organisational-area';
export const ORGANISATIONAL_AREA_EXPERIENCE = 'organisational-area-experience';